var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":_vm.fill,"viewBox":"0 0 1280 292.53"}},[_c('path',{attrs:{"d":"m640,292.53H0V0c155.13,179.17,384.32,292.53,640,292.53Z"}}),_vm._v(" "),_c('path',{attrs:{"d":"m1280,0v292.53h-640c255.68,0,484.87-113.36,640-292.53Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }